import { useEffect } from "react"

//components
import Loader from "components/app/components/Loader"
import NoResultsFound from "components/app/components/NoResultsFound"

//hooks
import useFetchClients from "../hooks/useFetchClients"

//providers
import { useFormDataContext } from "../providers/form"
import moment from "moment-timezone"
import useFetchClientHistory from "../hooks/useFetchClientHistory"

function ClientHistory({ handleValidations, viewFromHistory }) {

    const formData = useFormDataContext()
    const selectedClient = formData.getFieldForClient("client")

    const {
        loading,
        hasMore,
        setCurrentPage,
        getHistory,
        handleSearchByName,
        getPage,
    } = useFetchClientHistory()

    useEffect(() => {
        handleSearchByName(formData.getFieldForClient("clientName"))
    }, [formData.getFieldForClient("clientName")])

    function handleScrollList(e) {
        if (!hasMore || loading) return

        const { target } = e
        if (
            (target.scrollHeight - target.clientHeight).toFixed(0) - 1 <=
            target.scrollTop.toFixed(0)
        ) {
            setCurrentPage(getPage() + 1)
        }
    }

    function selectClient(client) {
        let { email, locations, name, number, id } = client
        if (id === selectedClient) {
            email = ""
            name = ""
            number = ""
            id = ""
            locations = []
        }

        formData.setFieldsFormats("client", id)
        formData.setFieldsFormats("clientName", name)
        formData.setFieldsFormats("clientLocation", locations[0]?.location || '')
        formData.setFieldsFormats("clientLocationId", locations[0]?.id || null)
        formData.setFieldsFormats("clientLocationsList", locations)
        formData.setFieldsFormats("clientPhone", number)
        formData.setFieldsFormats("clientEmail", email)
    }

    return (
        <div className="tab client-data">
            <div className="row">

                <div className="col list-col">
                    <b>Завършени задачи за {formData.getFieldForClient("clientName")}</b>
                    {getPage() === 1 && loading ? (
                        <Loader />
                    ) : getHistory().length === 0 ? (
                        <NoResultsFound text="Не бяха открити клиенти в списъка" />
                    ) : (
                        <ul onScroll={handleScrollList}>
                            {getHistory().map((c) => (
                                <li
                                    key={`c-${c.id}`}
                                >
                                    {c.favours?.service_name}
                                    <br />
                                        Платено: {c.cost ? c.cost+' лв.' : ''}
                                    <br />
                                    {moment(c.end).format("DD.MM.YYYY")}                                   
                                </li>
                            ))}
                            {loading ? (
                                <li>
                                    <Loader noPadding={true} />
                                </li>
                            ) : (
                                <></>
                            )}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ClientHistory
